export default __webpack_public_path__ + "static/media/Zeal of Atali.eca75981.jpg";